<template>
  <NodeViewWrapper class="button-node-view">
    <ButtonComponent
      :label="node.attrs.label"
      :icon="node.attrs.icon"
      :theme="node.attrs['data-cta']"
      :style="resolvedStyle"
      @click.prevent
    />
  </NodeViewWrapper>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'
import { NodeViewWrapper, nodeViewProps } from '@kvass/rich-text'

export default {
  name: 'ButtonView',
  components: {
    NodeViewWrapper,
    ButtonComponent,
  },
  props: nodeViewProps,
  inject: { RichTextOptions: { default: () => ({}) } },
  computed: {
    resolvedStyle() {
      const getThemes = this.RichTextOptions.button.getThemes
      if (typeof getThemes !== 'function') return this.node.attrs.style
      const theme = getThemes().find(t => t.value === this.node.attrs['data-cta'])
      return theme ? theme.style : this.node.attrs.style
    },
  },
}
</script>
